import { render, staticRenderFns } from "./EditAwardee.vue?vue&type=template&id=937a8e06&"
import script from "./EditAwardee.vue?vue&type=script&lang=js&"
export * from "./EditAwardee.vue?vue&type=script&lang=js&"
import style0 from "./EditAwardee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditAwardee.vue"
export default component.exports